
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { File } from "lucide-react";
import { useState } from "react";

interface DownloadFormatDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onFormatSelect: (format: "pdf" | "docx") => void;
  isPaid: boolean;
}

const DownloadFormatDialog = ({ 
  open, 
  onOpenChange,
  onFormatSelect,
  isPaid
}: DownloadFormatDialogProps) => {
  const [selectedFormat, setSelectedFormat] = useState<"pdf" | "docx">("pdf");
  
  const handleDownload = () => {
    onFormatSelect(selectedFormat);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Select Download Format</DialogTitle>
          <DialogDescription>
            Choose your preferred format for the resume download
          </DialogDescription>
        </DialogHeader>
        
        <div className="grid grid-cols-2 gap-4 py-4">
          <div 
            className={`flex flex-col items-center justify-center p-4 border rounded-md cursor-pointer transition-all ${selectedFormat === 'pdf' ? 'bg-blue-50 border-blue-300' : 'hover:bg-gray-50'}`}
            onClick={() => setSelectedFormat('pdf')}
          >
            <File className="h-10 w-10 text-red-500 mb-2" />
            <span>PDF</span>
          </div>
          
          <div 
            className={`flex flex-col items-center justify-center p-4 border rounded-md cursor-pointer transition-all ${selectedFormat === 'docx' ? 'bg-blue-50 border-blue-300' : 'hover:bg-gray-50'}`}
            onClick={() => setSelectedFormat('docx')}
          >
            <File className="h-10 w-10 text-blue-500 mb-2" />
            <span>DOCX</span>
          </div>
        </div>
        
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={handleDownload}>Download</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DownloadFormatDialog;
